import { pluralize } from '../../utils';
import { Campaign } from '../types';

export const getToggleLabel = (count: number, isCampaign?: boolean) =>
  `${count} ${pluralize(isCampaign ? 'Campaign' : 'URL', count)}`;

export const getCampaignIdToMetadataMap = (campaigns: Campaign[]) =>
  campaigns.reduce(
    (map, camp) => ({ ...map, [camp.campaignId]: camp }),
    {} as { [id: string]: Campaign },
  );
